var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-159 -1112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4629",
    "data-name": "Path 4629",
    d: "M47,0A47,47,0,1,1,0,47,47,47,0,0,1,47,0Z",
    transform: "translate(159 1112)",
    fill: "rgba(100,160,200,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M28.175,3A20.659,20.659,0,0,0,7.5,23.675c0,15.506,20.675,38.4,20.675,38.4s20.675-22.89,20.675-38.4A20.659,20.659,0,0,0,28.175,3Zm0,28.058a7.384,7.384,0,1,1,7.384-7.384A7.386,7.386,0,0,1,28.175,31.058Z",
    transform: "translate(177.825 1126.465)",
    fill: "#0046ad"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.ed551638a09d810660d78808f961c72e.svg";
export { ForwardRef as ReactComponent };